import { useEffect, useRef, useState } from 'react';

/** true si el usuario pidió reducir animaciones (o si no hay matchMedia, ej. jsdom). */
export const prefersReducedMotion = (): boolean =>
  typeof window === 'undefined' ||
  typeof window.matchMedia !== 'function' ||
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * Se vuelve true la primera vez que el elemento entra en pantalla (y queda así).
 * Sin IntersectionObserver (navegadores viejos, tests) devuelve true de entrada.
 */
export function useInView<T extends Element>(threshold = 0.3) {
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(() => typeof IntersectionObserver === 'undefined');

  useEffect(() => {
    const el = ref.current;
    if (!el || inView) return;
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setInView(true);
          obs.disconnect();
        }
      },
      { threshold },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [inView, threshold]);

  return [ref, inView] as const;
}
